<template>
  <div class="sky-search-box__search-box">
    <div class="sky-search-box__search-input-container" id="searchContainer">
      <el-input
        class="sky-search-box__search-input"
        :class="keywordList.length && !hideKeyWordList ? 'sky-search-box__search-input--active' : ''"
        :placeholder="$t('help.searchPlaceholder')"
        @input="handleSearchChange"
        v-model="searchKeyword"
        @focus="hideKeyWordList = false"
        @keyup.native.enter="handleInputChange"
      />
      <div v-if="keywordList.length && !hideKeyWordList" class="sky-search-box__search-list">
        <div class="sky-search-box__split"></div>
        <div
          class="sky-search-box__search-item"
          v-for="(item, index) in keywordList"
          :key="index"
          @click="handleKeywordClick(item.title)"
        >
          <tooltip-over :content="item.title" refName="searchBox" placement="right-end"></tooltip-over>
        </div>
      </div>
    </div>
    <el-button class="sky-search-box__search-button" type="primary" @click.native="handleSearch">
      <i class="sk-icon-search" />{{ $t('help.search') }}
    </el-button>
  </div>
</template>
<script>
import { Input, Button } from 'element-ui'

import { getSearchSuggest } from '@/api/help'
import TooltipOver from '@/components/tooltipOver'
export default {
  name: 'SearchBox',
  components: {
    [Input.name]: Input,
    [Button.name]: Button,
    TooltipOver
  },
  props: {
    value: {
      type: String,
      default() {
        return ''
      }
    }
  },
  watch: {
    searchKeyword(val) {
      this.$emit('input', val)
    }
  },
  data() {
    return {
      searchKeyword: this.value,
      keywordList: [],
      hideKeyWordList: true,
      timer: null
    }
  },
  created() {
    const _this = this
    document.documentElement.addEventListener('click', function(e) {
      if (!_this.hideKeyWordList && e.target.className !== 'el-input__inner') {
        _this.hideKeyWordList = true
      }
    })
  },
  methods: {
    handleSearchChange() {
      this.hideKeyWordList = false
      this.timer && clearTimeout(this.timer)
      console.log('input')
      this.timer = setTimeout(() => {
        this.handleGetSearchSuggest()
        this.timer && clearTimeout(this.timer)
      }, 100)
    },
    handleGetSearchSuggest() {
      console.log('search')
      getSearchSuggest({
        searchKeyword: this.searchKeyword,
        limit: 20
      }).then(response => {
        this.keywordList = response.data.content.itemArr
      })
    },
    handleKeywordClick(title) {
      this.searchKeyword = title
      this.$emit('search', title)
    },
    handleSearch() {
      this.$emit('search', this.searchKeyword)
    },
    handleInputChange(e) {
      this.hideKeyWordList = true
      this.$emit('search', this.searchKeyword)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(search-box) {
  @include e(search-box) {
    display: flex;
    position: relative;
    z-index: 2;
  }
  @include e(search-button) {
    width: 128px;
    height: 54px;
    background: #38a4f5;
    border-radius: 0px 2px 2px 0px;
    display: block;
    flex-shrink: 0;
    font-size: $--size-base;
    .sk-icon-search {
      font-size: 21px;
      font-weight: bold;
      margin-right: 10px;
    }
    border: none;
  }
  @include e(search-input-container) {
    position: relative;
    flex: 1;
  }
  @include e(search-list) {
    position: absolute;
    top: 52px;
    width: 100%;
    border: 2px solid $--color-primary;
    border-top: 0px;
    border-radius: 0 0 10px 10px;
    background: #ffffff;
    padding: 0px 16px 10px;
  }
  @include e(search-item) {
    padding-top: 5px;
    padding-bottom: 5px;
    cursor: pointer;
    font-size: $--size-base;
    color: $--color-grey-8;
    &:hover {
      background: $--color-grey-2;
    }
  }
  @include e(split) {
    height: 1px;
    width: 100%;
    background: $--color-grey-3;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.sky-search-box__search-input {
  width: 100%;
  .el-input__inner {
    width: 100%;
    height: 54px;
    background: #ffffff;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-right: none;
    transition: all 0.3s ease-in-out;
    &:focus {
      border: 2px solid $--color-primary;
      border-radius: 2px 0px 0px 2px;
    }
  }
}
.sky-search-box__search-input--active {
  .el-input__inner {
    border: 2px solid $--color-primary;
    border-radius: 2px 0px 0px 2px;
  }
}
</style>
